import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const Utilities = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query ApplicationsUtilitiesHeroImageQuery {
          file(relativePath: { eq: "meter.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 31px 38px 38px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 31px 52px 48px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 390px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 30px 38px 34px 40px;
          width: 388px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 48px 48px 42px 50px;
          width: 536px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 74px 76px 74px 80px;
          width: 571px;
        }
      `}
    >
      <Header2
        id="utility"
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 48px;
            line-height: 58px;
          }
        `}
      >
        {"Utilities"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 959px) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
            margin-top: 21px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 23px;
          }
        `}
      >
        {
          "Full flexible load control through dynamically controlled breakers, thermostats and smart home devices, provides intelligent Demand Side Management. Savant Power Distributed Energy Resources (DERs) are engineered to contribute to a Virtual Power Plant and perform valuable ancillary services."
        }
      </Paragraph>
    </Card>
  </Section>
);
